module.exports = __webpack_public_path__ + "static/media/how-to-start-image-2-1.e0e103bf.png";